module.exports = __webpack_public_path__ + "media/images/pages/who_we_are/Ebony-Sierra-45fc72db2c3fb6da2d67fd3d91b53647.png";